import React, { memo } from "react";
import classes from "./PlannerOverview.scss";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import withLoader from "UIComponents/GqlWithLoader";
import { updateTemplate } from "IBPlanner/modules/IBPlannerModule";
import { getUnitSummaryPlanQuery } from "IBPlanner/modules/IBQuery";
import { getUnitSummaryPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import {
  generateFieldListFromTemplateFields,
  getUnitPlanStagesMemoized,
} from "UnitPlans/modules/Utils";
import { getTemplateFieldQueryEnhancer } from "UnitPlans/modules/UnitPlanQueryEnhancers";
import {
  getSelectedAcademicYear,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE } from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";
import Accordion from "./components/Accordion";
import Header from "./components/Header";
import _ from "lodash";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";

const PlannerOverview = memo(function PlannerOverview(props) {
  const {
    unitPlanFields, //gives all data regarding Unit plan
    onClose, //close button function
    unitPlanTemplate, //Unit Template
    t, //Labels
    unitPlanDetails,
    selectedAcademicYear,
    isUnitFlowRevamp,
    testId,
  } = props;

  const unitSummaryModules = _.get(
    unitPlanTemplate,
    "unitSummaryModules",
    null
  );

  const updatedStageModuleLists = getUnitPlanStagesMemoized({
    unitPlanDetails,
    unitSummaryModules,
    module_list: _.get(unitPlanTemplate, "module_list", {}),
    unitPlanFields,
    stage_list: _.get(unitPlanTemplate, "stage_list", {}),
    step_list: _.get(unitPlanTemplate, "step_list", {}),
    field_list: _.get(unitPlanTemplate, "field_list", {}),
    fieldListV2: _.get(unitPlanTemplate, "fieldListV2", {}),
  });

  const updatedStageList = updatedStageModuleLists.updatedStageList;

  if (!isUnitFlowRevamp) {
    classes.accordionHeader = null;
  }

  return (
    <div className={classes.container}>
      <Header
        t={t}
        unitPlanFields={unitPlanFields}
        onClose={onClose}
        isUnitFlowRevamp={isUnitFlowRevamp}
        testId={`${testId}-plannerOverview-header`}
      />
      <div className={classes.scrollContainer}>
        <Accordion
          t={t}
          unitSummaryModules={unitSummaryModules}
          unitPlanFields={unitPlanFields}
          module_list={_.get(unitPlanTemplate, "module_list", {})}
          stage_list={_.get(unitPlanTemplate, "stage_list", {})}
          step_list={_.get(unitPlanTemplate, "step_list", {})}
          field_list={_.get(unitPlanTemplate, "field_list", {})}
          fieldListV2={_.get(unitPlanTemplate, "fieldListV2", {})}
          unitPlanDetails={unitPlanDetails}
          selectedAcademicYear={selectedAcademicYear}
          isUnitFlowRevamp={isUnitFlowRevamp}
          itemList={updatedStageList}
          testId={`${testId}-plannerOverview-header`}
          overrideClasses={classes}
        />
      </div>
    </div>
  );
});

const updateTemplateMemoize = _.memoize(
  ({
    template,
    unitType,
    curriculumType,
    resolvedSubjectNodes,
    t,
    fieldListV2,
  }) =>
    updateTemplate({
      t,
      template,
      unitType,
      curriculumType,
      resolvedSubjectNodes,
      fieldListV2,
    }),
  params => JSON.stringify(params)
);

const mapActionCreators = {};

const mapStateToProps = state => {
  const selectedAcademicYear = getSelectedAcademicYear(state);
  const currentCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const curriculumProgramId = getSelectedCurriculumId(state);
  const { isUnitFlowRevampEnabled } = getUnitFlowUtils();
  const isUnitFlowRevamp = isUnitFlowRevampEnabled();

  return {
    isData: true,
    isLoading: false,
    isUnitFlowRevamp,
    organizationId: state.login.userInfo.org_id,
    selectedAcademicYear,
    currentCurriculumProgramType,
    curriculumProgramId,
  };
};

const templateFieldQueryCallback = ({ data, ownProps }) => {
  const {
    t,
    unitPlanDetails,
    templateId,
    currentCurriculumProgramType,
  } = ownProps;

  const templateFromEnhancer = _.find(data, { id: templateId });
  const templateFields = _.get(templateFromEnhancer, [
    "templateField",
    "edges",
  ]);

  const fieldList = generateFieldListFromTemplateFields({
    templateFields,
    templateId,
  });

  const unitType = _.get(unitPlanDetails, "unitType.value", "");
  // let template;

  // switch (currentCurriculumProgramType) {
  //   case "IB_PYP":
  //     template = require("templates/PlannerTemplates/epypinquiry.json");
  //     break;
  //   case "UBD":
  //     template = require("templates/PlannerTemplates/ubd_toddle_2.0.json");
  //     break;
  //   case "IB_MYP":
  //     template = require("templates/PlannerTemplates/myp_interdisciplinary.json");
  //     break;
  //   case "IB_DP":
  //     template = require("templates/PlannerTemplates/dp_toddle.json");
  //     break;
  //   default:
  //     template = _.get(unitPlanDetails, "template", {});
  //     break;
  // }

  const template = _.get(unitPlanDetails, "template", {});

  const unitPlanFields = _.get(unitPlanDetails, "allFields", "");

  const curriculumType = _.get(unitPlanDetails, "curriculumProgram.type");

  const resolvedSubjectNodes = _.get(
    _.find(unitPlanFields, { uid: "subjects" }),
    "resolvedMinimalTree.subjects",
    []
  );

  const unitPlanTemplate = _.get(
    updateTemplateMemoize({
      t,
      template,
      unitType,
      curriculumType,
      resolvedSubjectNodes,
      fieldListV2: fieldList,
    }),
    "body",
    {}
  );

  return {
    unitPlanTemplate,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({
    resource: ["unitPlanTemplate", "unitPlan", "common", "projectTemplate"],
  }),
  graphql(getUnitSummaryPlanQuery, {
    name: "getUnitSummaryPlan",
    options: ({ unitPlanId, i18n }) => {
      const variables = { id: unitPlanId };

      if (ACLStore.can(ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE))
        variables.locale = i18n.language;
      return {
        fetchPolicy: "cache-and-network",
        variables,
      };
    },
    props({ getUnitSummaryPlan, ownProps: { isData, isLoading } }) {
      const unitPlanDetails = getUnitSummaryPlanDetailsFromCache(
        getUnitSummaryPlan.variables
      );

      const unitPlanFields = _.get(unitPlanDetails, "allFields", "");
      const templateId = _.get(unitPlanDetails, ["template", "id"], null);

      return {
        templateId,
        templateIds: [templateId],
        unitPlanDetails,
        unitPlanFields,
        isData: !_.isEmpty(unitPlanDetails) && isData,
        isLoading:
          getUnitSummaryPlan["networkStatus"] == 1 ||
          getUnitSummaryPlan["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  getTemplateFieldQueryEnhancer({ callback: templateFieldQueryCallback }),
  withLoader
)(PlannerOverview);

export { PlannerOverview };
